import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, PackageCheck, MessageCircle, Warehouse as WarehouseIcon, Globe } from "lucide-react";
import { Button } from "../components/ui/button";
import { Flag } from "../components/Flag";
import { useApp } from "../context/AppContext";
import { CONTACT_TEXT, waUrl } from "../waHelper";

export default function Coverage() {
  const nav = useNavigate();
  const { settings, countries, warehouses, t } = useApp();
  const [q, setQ] = useState("");
  const filtered = countries.filter((c) => c.name.toLowerCase().includes(q.toLowerCase()));

  return (
    <div>
      <section className="relative grid-bg border-b border-black/10 overflow-hidden">
        <div className="absolute -top-24 left-1/3 w-96 h-96 rounded-full bg-orange-600/15 blur-[120px]" />
        <div className="max-w-7xl mx-auto px-5 py-20 relative animate-fade-up">
          <span className="text-orange-500 text-sm font-semibold uppercase tracking-wider">{t("cov.eyebrow")}</span>
          <h1 className="font-display font-bold text-4xl md:text-5xl mt-3">{t("cov.title")}</h1>
          <p className="text-neutral-600 mt-4 max-w-2xl text-lg leading-relaxed">{t("cov.subtitle")}</p>
          <div className="mt-8 glass rounded-xl flex items-center px-4 h-12 max-w-md focus-within:border-orange-500/60 transition-colors">
            <Search className="w-4 h-4 text-neutral-500" />
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder={t("cov.searchPlaceholder")}
              className="bg-transparent flex-1 px-3 text-sm outline-none placeholder:text-neutral-300" />
          </div>
        </div>
      </section>

      {/* Warehouses */}
      <section className="max-w-7xl mx-auto px-5 py-16">
        <div className="flex items-center gap-2 mb-2"><WarehouseIcon className="w-5 h-5 text-orange-500" /><h2 className="font-display font-bold text-2xl">{t("cov.warehouses")}</h2></div>
        <p className="text-neutral-600 text-sm mb-6">{t("cov.warehousesSub")}</p>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">
          {warehouses.map((w) => (
            <div key={w.id} className="glass card-hover rounded-xl p-4">
              <div className="mb-2"><Flag emoji={w.flag} className="w-10 h-7" /></div>
              <p className="text-sm font-semibold">{w.city}</p>
              <p className="text-xs text-neutral-500">{w.country}</p>
            </div>
          ))}
        </div>
      </section>

      {/* All countries */}
      <section className="max-w-7xl mx-auto px-5 pb-20">
        <div className="flex items-center gap-2 mb-2"><Globe className="w-5 h-5 text-orange-500" /><h2 className="font-display font-bold text-2xl">{t("cov.countries")} {q && <span className="text-neutral-500 text-base font-normal">— {filtered.length} {t("cov.match")}</span>}</h2></div>
        <p className="text-neutral-600 text-sm mb-6">{t("cov.countriesSub")}</p>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
          {filtered.map((c) => (
            <button key={c.id || c.name} onClick={() => nav("/send")} className="glass card-hover rounded-xl p-4 text-left">
              <div className="mb-2"><Flag emoji={c.flag} className="w-10 h-7" /></div>
              <p className="text-sm font-medium">{c.name}</p>
              <p className="text-[11px] text-green-500 flex items-center gap-1 mt-1"><PackageCheck className="w-3 h-3" /> {t("cov.available")}</p>
            </button>
          ))}
        </div>
        {!filtered.length && (
          <div className="glass rounded-2xl p-8 text-center">
            <p className="text-neutral-600">{t("cov.notFound")}</p>
            <a href={waUrl(settings.whatsapp, CONTACT_TEXT)} target="_blank" rel="noreferrer">
              <Button className="orange-gradient text-white border-0 mt-4 gap-2 hover:opacity-90"><MessageCircle className="w-4 h-4" /> {t("cov.ask")}</Button>
            </a>
          </div>
        )}
      </section>
    </div>
  );
}
